import { History } from 'history'
import { FilterValues } from '../../context/PaginationContext'
import { obfuscateData } from '../helpers'

export interface PaginationQueryParams {
  page: number
  size: number
  searchQuery?: string
  sort?: string
  filters?: FilterValues
}

export const setPaginationQueryParams = (
  params: PaginationQueryParams,
  history: History,
) => {
  const searchParams = new URLSearchParams()

  searchParams.set('page', params.page.toString())
  searchParams.set('size', params.size.toString())

  if (params?.searchQuery) {
    searchParams.set('searchQuery', obfuscateData(params.searchQuery))
  }

  if (params?.sort) {
    searchParams.set('sort', params.sort)
  }

  if (params.filters && Object.keys(params.filters).length) {
    const filterStrings = Object.entries(params.filters).map(
      ([key, values]) => `${key}:${values}`,
    )
    const filtersString = filterStrings.join(';')
    searchParams.set('filters', filtersString)
  }

  history.push({ search: searchParams.toString() })
}
